import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import {createServer} from 'miragejs';

// createServer({
//   routes() {
//     this.namespace = 'api';

//     this.get('/tracking', () => {
//       return {
//         id:"HRG559ED6BE68BR",
//           notaFiscal:7045625,
//           serie:106,
//           chaveNfe:"52240678876950012340551060070456251382149977",
//           previsaoEntrega:"2024-06-26T03:00:00",
//           cepEntrega:"05846050",
//           documentoCliente:"27874791894",
//           pedido:"v7813982hrg-01",
//           status:"Entregue",
//           eventos:[
//              {
//                 transportador:"Total",
//                 imagemTransportador:"https:\/\/rastreio.ciahering.com.br\/static\/img\/logo-total-express.png",
//                 metodoEnvio:"Serviço Normal Total v1",
//                 historicoEventos:[
//                    {
//                       evento:"Inicial",
//                       dataHora:"2024-06-20T03:00:00",
//                       detalhe:"A Entrega foi criada com sucesso. Aguarde os demais status de rastreamento"
//                    },
//                    {
//                       evento:"Em Transito",
//                       dataHora:"2024-06-24T07:51:05",
//                       detalhe:"ARQUIVO RECEBIDO"
//                    },
//                    {
//                       evento:"Em Transito",
//                       dataHora:"2024-06-27T11:59:25",
//                       detalhe:"COLETA RECEBIDA COM NC NO CD DE"
//                    },
//                    {
//                       evento:"Em Transito",
//                       dataHora:"2024-06-27T11:59:25",
//                       detalhe:"RECEBIDA E PROCESSADA NO CD - : HUB\/MATRIZ"
//                    },
//                    {
//                       evento:"Em Transito",
//                       dataHora:"2024-06-27T11:59:25",
//                       detalhe:"AGUARDANDO CUBAGEM"
//                    },
//                    {
//                       evento:"Saiu para entrega",
//                       dataHora:"2024-07-01T10:31:06",
//                       detalhe:"PROCESSO DE ENTREGA"
//                    },
//                    {
//                       evento:"Saiu para entrega",
//                       dataHora:"2024-07-01T11:00:03",
//                       detalhe:"PROCESSO DE ENTREGA"
//                    },
//                    {
//                       evento:"Entregue",
//                       dataHora:"2024-07-01T14:20:30",
//                       detalhe:"ENTREGA REALIZADA"
//                    }
//                 ]
//              },
//              {
//                 transportador:"APK",
//                 imagemTransportador:"https:\/\/rastreio.ciahering.com.br\/static\/img\/logo-apk.png",
//                 metodoEnvio:"Serviço Normal Total v1",
//                 historicoEventos:[
//                    {
//                       evento:"Em Transito",
//                       dataHora:"2024-06-25T02:59:00",
//                       detalhe:"EM TRANSITO"
//                    },
//                    {
//                       evento:"Entregue pela Transportadora Auxiliar",
//                       dataHora:"2024-06-26T17:00:00",
//                       detalhe:"Coletado Transportadora Last Mile"
//                    }
//                 ]
//              }
//           ]
//         }
//     });
//   }
// });

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);